import { getStoreLanguages } from '../Common/Providers/StoreLanguagesApi';
import { isCrawler } from '../Common/Helpers/GetOs';
import Cookies from 'js-cookie';

const resolveLanguageCode = (storeCode) => {
  const storeLanguages = getStoreLanguages(storeCode);
  const pathLanguageCode = window.location.pathname.split('/')[1];
  if (isValidLanguage(storeLanguages, pathLanguageCode)) {
      return pathLanguageCode;
  }
  return getDefaultLanguage(storeLanguages)
}

const getLocaleCookie = () => {
  return Cookies.get('langCode');
}

export const setLocaleCookie = (lang) => {
  return Cookies.set('langCode', lang, { expires: 365 });
}

export const isValidLanguage = (storeLanguages = [], lang = '') => storeLanguages.some(l => l.code === lang)

export const isDefaultLanguage = (storeLanguages = [], lang = '') => storeLanguages.some(l => l.code === lang && l.is_default == 1)

export const getDefaultLanguage = (storeLanguages) => {
  const defaultLanguage = storeLanguages.find(l => l.is_default == 1);
  return defaultLanguage ? defaultLanguage.code : 'en';
}

export const getUseableLangCode = (storeCode) => {
  if (isCrawler()) {
      return resolveLanguageCode(storeCode);
  } else {
      if (getLocaleCookie()) {
          return getLocaleCookie();
      } else {
          const resolvedLanguageCode = resolveLanguageCode(storeCode);
          setLocaleCookie(resolvedLanguageCode);
          return resolvedLanguageCode;
      }
  }
}

//Keep the alias wrapper so we don't have to change config files across environments 
export const getAPILocale = (storeCode) => {
  return getUseableLangCode(storeCode);
};



// WEBPACK FOOTER //
// ./src/Locale/Locale.js